import MyOrdersStoreAction from "./action";

class MyOrdersStoreClass extends MyOrdersStoreAction {}

export default MyOrdersStoreClass;
